import { TemplateDto } from "@exibra/shared";
import { ApiService } from "./api/api.service";

class TemplateService extends ApiService {
    private readonly API_URL = "/api/templates";

    async getCustomTemplates(tenantId: number): Promise<TemplateDto[]> {
        const response = await this.axios.get(`${this.API_URL}/custom`, {
            params: {
                tenantId,
            },
        });
        return response.data;
    }

    async saveTemplate(template: TemplateDto): Promise<TemplateDto> {
        if (template.isCustom && template.id) {
            // Update existing template
            const response = await this.axios.put(
                `${this.API_URL}/custom/${template.id}`,
                template,
            );
            return response.data;
        } else {
            // Create new template
            const response = await this.axios.post(`${this.API_URL}/custom`, template);
            return response.data;
        }
    }

    async deleteTemplate(templateId: number): Promise<void> {
        await this.axios.delete(`${this.API_URL}/custom/${templateId}`);
    }

    async uploadImage(file: File): Promise<string> {
        const formData = new FormData();
        formData.append("image", file);

        const response = await this.axios.post(`${this.API_URL}/upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data.url;
    }

    async getTemplateById(templateId: number): Promise<TemplateDto> {
        const response = await this.axios.get(`${this.API_URL}/custom/${templateId}`);
        return response.data;
    }
}

export const templateService = new TemplateService();
